/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './messages.tpl.html';

angular
  .module('batch.messages', [])
  /**
   * Controller for the batch.messages template.
   */
  .controller('BatchMessagesCtrl', function ($scope, $filter, batchUtils) {
    var DEFAULT_TITLE = '500_TITLE',
      DEFAULT_MSG = '500_MESSAGE';
    $scope.TITLE_POST = '_TITLE';
    $scope.MSG_POST = '_MESSAGE';
    $scope.batchUtils = batchUtils;
    $scope.messages = $scope.batchUtils.currentBatch.events;

    /**
     * Get the message that should be displayed based on the code from the message and where it will be displayed.
     *
     * @param {Number} code - The error code.
     * @param {String} postFix - Should be one of the Strings defined in this file.
     * @param {Object} [msgObj] - The message object for the error.
     * @returns {string} The message for the key/postfix combination. Not if the code is not found it will return a default message for the
     *  postfix.
     */
    $scope.getCodeStr = function (code, postFix, msgObj) {
      var key = code + postFix,
        type = $filter('i18n')($scope.batchUtils.currentBatch.type || 'BACKUP').toLowerCase(),
        str;

      msgObj = msgObj || {
        message: '',
        type: type
      };

      str = msgObj.message;

      if (postFix === $scope.TITLE_POST) {
        if (SBSF.messages[key]) {
          str = $filter('i18n')(key, [type]);
        } else {
          str = $filter('i18n')(DEFAULT_TITLE);
        }
      } else if (postFix === $scope.MSG_POST) {
        if (code === 104) {
          // backup failure
          if (msgObj.message !== null) {
            str = $filter('i18n')(key, [msgObj.type, msgObj.message]);
          } else {
            str = $filter('i18n')('104_MESSAGE_NO_DETAILS', [msgObj.type]);
          }
        } else if (code === 105) {
          // batch level failure
          if (msgObj.message !== null) {
            str = $filter('i18n')(key, [msgObj.type, msgObj.message]);
          } else {
            str = $filter('i18n')('105_MESSAGE_NO_DETAILS', [msgObj.type]);
          }
        } else if (code === 500) {
          // general error just spit out general message
          str = msgObj ? msgObj.message : '';
        } else if (SBSF.messages[key]) {
          // see if map to existing message
          str = $filter('i18n')(key, [type]);
        } else {
          str = $filter('i18n')(DEFAULT_MSG, [type, msgObj.message]);
        }
      }
      return str;
    };

    /**
     * Get the boink css class for a given message based on the severity.
     *
     * @param {String} severity- The severity from the message object.
     * @returns {String} The css to apply to the boink component.
     */
    $scope.getBoinkCls = function (severity) {
      var cls;
      if (severity === $scope.batchUtils.EVENT_TYPES.ERROR) {
        cls = $scope.batchUtils.STATUS.FAILURE.bigBoinkCls;
      } else {
        cls = $scope.batchUtils.STATUS.PARTIAL.bigBoinkCls;
      }
      return cls;
    };

    /**
     * Function used to hide the messages component.
     */
    $scope.hideMessages = function () {
      $scope.$parent.showMessages = !$scope.$parent.showMessages;
    };

    // Anytime that the currentBatch changes update the messages for the UI.
    $scope.$watch(
      function () {
        return $scope.batchUtils.currentBatch;
      },
      function () {
        $scope.messages = $scope.batchUtils.currentBatch.events;
      }
    );
  });
